import createImageUrlBuilder from "@sanity/image-url"

import { getSanityDataset, getSanityProjectId } from "./sanity_client"
import type { SanityImageField } from "./types"

export function url_for_sanity_image(
  image: SanityImageField | null | undefined,
  width: number = 1200
): string | null {
  const projectId = getSanityProjectId()
  const dataset = getSanityDataset()
  if (!projectId || !dataset || !image?.asset?._ref) {
    return null
  }
  const builder = createImageUrlBuilder({ projectId, dataset })
  return builder.image(image).width(width).auto("format").url()
}
